import module from '../module';
import Constants from '../../../utils/CommonConstants';

function OrderPayController($scope, $stateParams, groupOrder, $state) {

    $scope.paymentDetails = {
        cardNumber: '',
        cardName: '',
        expirationDate: '',
        securityCode: '',
        payTitle: 'client.pay_now',
        amountToPay: groupOrder.getAmountToPay()
    };

    /*jshint -W041 */
    if ($scope.paymentDetails.amountToPay == 0) {
        $state.go(Constants.RoutingStates.CATALOG);
        return;
    }
    /*jshint +W041 */

    $scope.payNow = function (form) {

        if (!form.$valid) {
            form.highlightAllErrors();
            return;
        }

        groupOrder.payNow({
            cardNumber: $scope.paymentDetails.cardNumber,
            cardName: $scope.paymentDetails.cardName,
            expirationDate: $scope.paymentDetails.expirationDate,
            securityCode: $scope.paymentDetails.securityCode,
            id: $stateParams.id
        }).then(function () {
            $state.go(Constants.RoutingStates.CONFIRM_ORDER);
        });
    };
}

module.controller('Cartonomy.Order.PayController', ['$scope', '$stateParams', 'GroupOrder', '$state', OrderPayController]);


// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderPayController.js